import { Container } from "react-bootstrap";

function UpNav() {
  return (
    <div className="layout layout__bg_primary upNav">
      <Container fluid>
        <h6 className="text-center upNav_text">
          % Bringe einen Freund mit und sichere dir einen 50€ Gutschein für
          deine nächste Fahrstunde!
        </h6>
      </Container>
    </div>
  );
}

export default UpNav;
